enum GeoLocalizationStatic {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get cities
   */
  citiesList = "/v2/cities",
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get cities
   */
  sectorsList = "/v2/sectors",
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description create sectors
   */
  createSectors = "/v2/sectors",
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description get Coutries
   */
  countriesList = "/v2/countries"
}

const GeoLocalizationDynamic = {
  // /**
  //  * @member {string}
  //  * @method post
  //  * @version 2.0
  //  * @description google social network login
  //  */
  // LoggedUserGoogleCallback: (search: string) =>
  //   `/v2/users/login/google/callback${search}`,
};

export const GeoLocalizationEndpoints = {
  ...GeoLocalizationDynamic,
  ...GeoLocalizationStatic
};

export type GeoLocalizationEndpoints = typeof GeoLocalizationEndpoints;
